import { BUTTON_HEIGHT, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  margin-top: 4px;

  #main-layout:has(.mobile &) {
    padding: 0 !important;
  }

  .ag-header-group-cell-with-group {
    border-left: 1px solid #bcbcbc;
    .ag-header-group-text {
      width: 100%;
      text-align: center;
    }
  }
  .ag-cell {
    padding: 0 4px;
  }

  .ag-theme-alpine {
    .ag-cell:has(.missed) {
      background-color: #f5cccc;
      color: #820014;
    }

    .ag-sort-indicator-container,
    .ag-header-cell-menu-button {
      display: none !important;
    }

    .ag-header-cell-text {
      font-size: var(--ag-font-size);
      font-weight: 700;
      color: var(--ag-header-foreground-color);
    }

    .title_container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0px;
    }

    .title_container .header-icon-filter {
      width: ${({ text_scale }) =>
        text_scale === DISPLAY_SIZES.SMALL
          ? `${BUTTON_HEIGHT[DISPLAY_SIZES.SMALL] - 3}px`
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? `${BUTTON_HEIGHT[DISPLAY_SIZES.MEDIUM] - 5}px`
          : `${BUTTON_HEIGHT[DISPLAY_SIZES.LARGE] - 8}px`} !important;

      height: ${({ text_scale }) =>
        text_scale === DISPLAY_SIZES.SMALL
          ? `${BUTTON_HEIGHT[DISPLAY_SIZES.SMALL] - 3}px`
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? `${BUTTON_HEIGHT[DISPLAY_SIZES.MEDIUM] - 5}px`
          : `${BUTTON_HEIGHT[DISPLAY_SIZES.LARGE] - 8}px`} !important;
      border-radius: 3px;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .title_container .header-icon-filter.bg-blue-light {
      background: #58a7ff !important;
    }
    .title_container .header-icon-filter.bg-blue {
      background: #2d8cff !important;
    }

    .tracking-list-actions {
      .ant-btn {
        min-width: 56px;
        padding: 0 8px;
        height: 28px;
        font-size: 12px;
        border-radius: 6px;
        background: #6a8dff;
        border-color: #1e3666;
        color: #fff;
        box-shadow: 0px 2px 0px 0px #3a0a0a0b;

        &:hover:not(:disabled) {
          background: #69b1ff !important;
          border-color: #69b1ff !important;
          color: #fff !important;
        }
      }
    }

    .tracking-info-icons {
      justify-content: center;
    }

    .ag-cell[col-id="memo"] {
      overflow: hidden;
    }
  }

  .mobile & {
    --header-cell-bg: #4e525b;
    --header-cell-color: #ffffff;

    --odd-row-cell-bg: #000000;
    --odd-row-cell-color: #ffffff;

    --even-row-cell-bg: #000000;
    --even-row-cell-color: #ffffff;

    --row-hover-bg: #2d3748;

    .wrapper-scroll-bar-horizontal {
      border-bottom: 1px solid #2d3748;
      background: #1a1a1a;
    }

    .table-wrapper {
      border-color: #2d3748;
      background: #000000;
    }

    .ag-root-wrapper,
    .ag-root {
      background-color: #000000 !important;
    }

    .ag-body-viewport {
      background-color: #000000 !important;
    }

    .ag-center-cols-container {
      background-color: #000000 !important;
    }

    .ag-header-viewport {
      border-top-color: #2d3748 !important;
    }

    .ag-header {
      border-bottom-color: #2d3748 !important;
      background-color: #4e525b !important;
    }

    .ag-header-cell:not(.ag-header-cell-auto-height)
      .ag-header-cell-comp-wrapper {
      background-color: #4e525b !important;
      color: #ffffff !important;
    }

    .ag-header-cell .ag-header-cell-comp-wrapper {
      color: #ffffff !important;
    }

    .ag-header-cell,
    .ag-header-group-cell {
      background-color: #4e525b !important;
      border-left-color: #2d3748 !important;
    }

    .ag-header-cell:hover {
      background-color: #4e525b !important;
    }

    .ag-header-row.ag-header-row-column-filter {
      background-color: #2d3748 !important;
    }

    .ag-header-cell.ag-floating-filter {
      background-color: #2d3748 !important;
      border-top-color: #2d3748 !important;
    }

    .ag-row {
      border-bottom-color: #2d3748 !important;
      background-color: #000000 !important;
    }

    .ag-row-odd,
    .ag-row-even {
      background-color: #000000 !important;
    }

    .ag-row-hover::before {
      background-color: #2d3748 !important;
    }

    .ag-ltr .ag-cell {
      border-left-color: #2d3748 !important;
      color: #ffffff !important;
    }

    .ant-input-affix-wrapper.input-field.timer,
    .ant-input-affix-wrapper.input-field.timer > input.ant-input,
    .ant-input-affix-wrapper.input-field.timer .ant-input-clear-icon,
    .ant-input-affix-wrapper.input-field.timer .ant-input-suffix {
      color: #ffffff !important;
    }

    .ag-header-cell-text {
      color: #ffffff !important;
    }

    .ag-theme-alpine .title_container,
    .ag-theme-alpine .title_container span {
      color: #ffffff !important;
    }

    .ag-icon-asc::before,
    .ag-icon-desc::before {
      color: rgba(255, 255, 255, 0.85) !important;
    }

    .ag-icon.ag-icon-none::before {
      color: rgba(255, 255, 255, 0.45) !important;
    }

    .ag-pinned-left-header,
    .ag-pinned-right-header {
      border-top-color: #2d3748 !important;
      background-color: #4e525b !important;
    }

    .ag-pinned-left-header {
      border-right-color: #2d3748 !important;
    }

    .ag-pinned-right-header {
      border-left-color: #2d3748 !important;
    }

    .ag-pinned-left-cols-container,
    .ag-pinned-right-cols-container {
      border-color: #2d3748 !important;
      background-color: #000000 !important;
    }

    .ag-pinned-left-cols-container .ag-cell,
    .ag-pinned-right-cols-container .ag-cell {
      background-color: #000000 !important;
    }

    .ag-input-field-input {
      border-bottom-color: #4a5568 !important;
      background-color: transparent !important;
      color: #ffffff !important;
    }

    .ag-header-cell .floatingFilter-select {
      border-bottom-color: #2d3748 !important;
    }

    .ag-header-cell .floatingFilter-select select {
      color: rgba(255, 255, 255, 0.45) !important;
      background-color: transparent !important;
    }

    .ag-overlay-wrapper.ag-layout-normal.ag-overlay-no-rows-wrapper {
      color: rgba(255, 255, 255, 0.65) !important;
    }
  }

  .desktop &.lhd-tracking-list-table {
    --header-cell-bg: #4e525b;
    --header-cell-color: #ffffff;

    --odd-row-cell-bg: #ffffff;
    --odd-row-cell-color: #434343;

    --even-row-cell-bg: #fafafa;
    --even-row-cell-color: #434343;

    --row-hover-bg: #f0f0f0;

    .ag-theme-alpine {
      --ag-header-background-color: #4e525b;
      --ag-header-foreground-color: #ffffff;
      --ag-secondary-foreground-color: #ffffff;
    }

    .table-wrapper {
      border: none;
      .btn-group {
        padding: 8px 0;
      }
    }

    .ag-theme-alpine .ag-header-cell-text {
      color: #ffffff !important;
      font-weight: 700;
    }

    .ag-theme-alpine .ag-header {
      background-color: #4e525b !important;
      border-bottom-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-header-viewport {
      border-top-color: #bcbcbc !important;
    }

    .ag-theme-alpine
      .ag-header-cell:not(.ag-header-cell-auto-height)
      .ag-header-cell-comp-wrapper {
      background-color: #4e525b !important;
      color: #ffffff !important;
    }

    .ag-theme-alpine .ag-header-cell .ag-header-cell-comp-wrapper {
      color: #ffffff !important;
    }

    .ag-theme-alpine .ag-header-cell,
    .ag-theme-alpine .ag-header-group-cell {
      background-color: #4e525b !important;
      border-left-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-header-cell:hover {
      background-color: #3b3e45 !important;
    }

    .ag-theme-alpine .ag-header-row.ag-header-row-column-filter {
      background-color: #ffffff !important;
    }

    .ag-theme-alpine .ag-header-cell.ag-floating-filter {
      background-color: #ffffff !important;
      border-top-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-pinned-left-header,
    .ag-theme-alpine .ag-pinned-right-header {
      background-color: #4e525b !important;
      border-top-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-pinned-left-header {
      border-right-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-pinned-right-header {
      border-left-color: #bcbcbc !important;
    }

    .ag-theme-alpine .ag-icon-asc::before,
    .ag-theme-alpine .ag-icon-desc::before {
      color: #777777 !important;
    }

    .ag-theme-alpine .ag-icon.ag-icon-none::before {
      color: #777777 !important;
    }

    .ag-theme-alpine .title_container,
    .ag-theme-alpine .title_container span {
      color: #ffffff !important;
    }
  }

  .ag-header-cell {
    padding: 0 3px;
  }

  .ant-table-cell {
    padding: 8px 6px;
  }

  .ant-table-cell-row-hover {
    background: var(--row-hover-bg) !important;
    color: var(--odd-row-cell-color) !important;
  }

  .ant-table-tbody > .ant-table-row:nth-child(odd) {
    background: var(--odd-row-cell-bg);
    color: var(--odd-row-cell-color);
  }

  .ant-table-tbody > .ant-table-row:nth-child(even) {
    background: var(--even-row-cell-bg);
    color: var(--even-row-cell-color);
  }

  .ant-table-tbody > .ant-table-row:nth-child(odd) > .ant-table-cell-fix-left,
  .ant-table-tbody > .ant-table-row:nth-child(odd) > .ant-table-cell-fix-right {
    background: var(--odd-row-cell-bg) !important;
    color: var(--odd-row-cell-color);
  }

  .ant-table-tbody > .ant-table-row:nth-child(even) > .ant-table-cell-fix-left,
  .ant-table-tbody
    > .ant-table-row:nth-child(even)
    > .ant-table-cell-fix-right {
    background: var(--even-row-cell-bg) !important;
    color: var(--even-row-cell-color);
  }

  .ant-table-tbody .ant-table-cell-fix-left::after,
  .ant-table-tbody .ant-table-cell-fix-right::after {
    border-color: rgba(255, 255, 255, 0.12) !important;
  }

  .ant-table-thead .ant-table-cell {
    background: var(--header-cell-bg);
    color: var(--header-cell-color);
    font-weight: 600;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .mobile & .ant-table-thead .ant-table-cell {
    border-color: rgba(255, 255, 255, 0.12);
  }

  .ant-table {
    background: transparent;
  }

  .ant-table-container {
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    overflow: hidden;
  }

  .mobile & .ant-table-container {
    border-color: rgba(255, 255, 255, 0.12);
  }

  .title_container {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
  }

  .tracking-list-actions {
    padding: 0 12px;
    .ant-btn {
      min-width: 56px;
      padding: 0 8px;
      height: 28px;
      font-size: 12px;
      border-radius: 6px;
    }

    .btn-edit.ant-btn-primary {
      background: #6a8dff;
      border-color: #1e3666;

      &:hover:disabled {
        opacity: 0.8;
        background: #bcbcbc;
        border-color: #bcbcbc;
      }

      &:disabled {
        background: #bcbcbc;
        border-color: #bcbcbc;
        color: #fff;
        cursor: not-allowed;
      }
    }
  }

  .tracking-info-icons {
    justify-content: center;
  }

  .table-wrapper {
    position: relative;
  }

  .ant-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-prev,
  .ant-pagination .ant-pagination-next {
    margin: 0 !important;
  }

  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    min-width: 28px;
    height: 28px;
    line-height: 26px;
    border: 1.5px solid #d9d9d9;
    background: #fff;
    color: #fff;

    .desktop & {
      color: #000;
    }
  }

  .ant-pagination .ant-pagination-item a {
    color: #000;
    font-weight: 700;
  }

  .ant-pagination .ant-pagination-item-active {
    background: #174a83;
    border-color: #174a83;
  }

  .ant-pagination .ant-pagination-item-active a {
    color: #fff;
    font-weight: 600;
  }

  .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    border: none;
    background: transparent;
  }

  .ant-pagination .ant-select {
    min-width: 72px;
  }

  .ant-pagination .ant-select-selector {
    height: 28px !important;
    border-radius: 6px !important;
    border: 1px solid #d9d9d9 !important;
    background: #fff !important;
    color: #262626 !important;
  }

  .ant-pagination .ant-select-selection-item,
  .ant-pagination .ant-select-arrow {
    color: #262626;
  }

  .ant-pagination .ant-pagination-item-ellipsis {
    color: #fff;

    .desktop & {
      color: #000;
    }
  }

  .mobile & {
    .btn-group > .month-picker-wrap {
      width: 100%;
    }

    .btn-group > .month-picker-wrap .ant-picker {
      width: 100%;
    }

    .btn-group > .footer {
      width: 100%;
      margin-top: 0;
    }

    .ant-table-thead .ant-table-cell:has(.scroll-row) {
      background: var(--header-cell-bg) !important;
    }

    .ant-table-cell:has(.vertical-scroll-bar-inside) {
      background: var(--odd-row-cell-bg) !important;
    }

    .ant-table-cell.ant-table-cell-row-hover {
      background: transparent !important;
    }

    .ant-table {
      border-color: rgba(255, 255, 255, 0.12);
    }

    .ant-table-tbody > tr > td,
    .ant-table-thead > tr > th {
      border-color: rgba(255, 255, 255, 0.12);
    }

    .ant-table-tbody > .ant-table-row:nth-child(odd) > .ant-table-cell-fix-left,
    .ant-table-tbody
      > .ant-table-row:nth-child(odd)
      > .ant-table-cell-fix-right {
      background: var(--odd-row-cell-bg) !important;
    }

    .ant-table-tbody
      > .ant-table-row:nth-child(even)
      > .ant-table-cell-fix-left,
    .ant-table-tbody
      > .ant-table-row:nth-child(even)
      > .ant-table-cell-fix-right {
      background: var(--even-row-cell-bg) !important;
    }

    .ant-pagination {
      justify-content: flex-start;
      gap: 4px;
      flex-wrap: wrap;
      width: 100%;
    }

    .ant-pagination .ant-pagination-item,
    .ant-pagination .ant-pagination-prev,
    .ant-pagination .ant-pagination-next,
    .ant-pagination .ant-pagination-jump-prev,
    .ant-pagination .ant-pagination-jump-next {
      flex: 0 0 auto;
    }

    .ant-pagination .ant-pagination-item,
    .ant-pagination .ant-pagination-prev,
    .ant-pagination .ant-pagination-next,
    .ant-pagination .ant-pagination-jump-prev,
    .ant-pagination .ant-pagination-jump-next {
      order: 1;
    }

    .footer .pagination .ant-pagination {
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      padding-bottom: 2px;
    }

    .footer .pagination .ant-pagination::-webkit-scrollbar {
      display: none;
    }
  }
`;
